import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllCampsitesQuery } from '@custom/schema';

export const useAllCampsites = () => {
  return useStaticQuery(graphql(AllCampsitesQuery));
};
